<section class="fullWidthCls admPageSec marginAtTop">
  <div class="container-fluid">
    <div class="row">
      <div class="admPageTitleSec">
        <p class="admPageTitle">
          <i class="material-icons cusIconSize">&#xE8B4;</i>
          <span>Manage Locations</span>
        </p>
      </div>
      <div class="admBreadcumTitle">
        <p class="admManageExamBreadcumCls">
          <span>
            <a [showUnSavedChangesAlert]="{ form: form, redirect: 'AdmManageLocation'}" class="searchFormLink">Manage Training Centers</a>
            &gt;
            <span class="addEditFormLink">{{title}}</span>
          </span>
        </p>
      </div>
      <md-card>
        <md-card-header>
          <div class="admPageHeadingSec">
            <md-card-title>
              <div class="admPageHeading">
                <p>
                  <span>{{title}}</span>
                </p>
              </div>
            </md-card-title>
          </div>
        </md-card-header>

        <md-card-content>
          <form class="example-form" novalidate [formGroup]="form">

            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="Region" mdInput formControlName="regionId" [mdAutocomplete]="region"  [showDropDown]="{model: 'region', scope : this }">
                  <md-autocomplete #region="mdAutocomplete" [displayWith]="_utility.displayFn">
                    <md-option *ngFor="let option of (regionFilteredOptions | async)" [value]="option">
                      {{ option.name }}
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
                <p class="validate" *ngIf="form.controls.regionId.touched && form.controls.regionId.errors && form.controls.regionId.errors.validId">Please select a valid value</p>
                <p requiredField *ngIf="form.controls.regionId.touched && form.controls.regionId.errors && form.controls.regionId.errors.required"></p>
              </div>
            </div>
            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Address Street-1" formControlName="address1" maxlength="100">
                </md-form-field>
                <p requiredField *ngIf=" form.controls.address1.touched && form.controls.address1.invalid"></p>
              </div>
            </div>
            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Address Street-2" formControlName="address2" maxlength="100">
                </md-form-field>
              </div>
            </div>



            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="Country" mdInput formControlName="countryId" [mdAutocomplete]="country"  [showDropDown]="{model: 'country', scope : this }">
                  <md-autocomplete #country="mdAutocomplete" [displayWith]="_utility.displayFn">
                    <md-option *ngFor="let option of countryFilteredOptions | async" [value]="option">
                      {{ option.name }}
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
                <p class="validate" *ngIf="form.controls.countryId.touched && form.controls.countryId.errors && form.controls.countryId.errors.validId">Please select a valid value</p>
                <p requiredField *ngIf="form.controls.countryId.touched && form.controls.countryId.errors && form.controls.countryId.errors.required"></p>
              </div>
            </div>

            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="State" mdInput formControlName="stateId" [mdAutocomplete]="state"  [showDropDown]="{model: 'state', scope : this }">
                  <md-autocomplete #state="mdAutocomplete" [displayWith]="_utility.displayFn">
                    <md-option *ngFor="let option of stateFilteredOptions | async" [value]="option">
                      {{ option.name }}
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
                <p class="validate" *ngIf="form.controls.stateId.touched && form.controls.stateId.errors && form.controls.stateId.errors.validId">Please select a valid value</p>
                <p requiredField *ngIf="form.controls.stateId.touched && form.controls.stateId.errors && form.controls.stateId.errors.required"></p>
              </div>

            </div>
            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="City" mdInput formControlName="cityId" [mdAutocomplete]="city"  [showDropDown]="{model: 'city', scope : this }">
                  <md-autocomplete #city="mdAutocomplete" [displayWith]="_utility.displayFn">
                    <md-option *ngFor="let option of cityFilteredOptions | async" [value]="option">
                      {{ option.name }}
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
                <p class="validate" *ngIf="form.controls.cityId.touched && form.controls.cityId.errors && form.controls.cityId.errors.validId">Please select a valid value</p>
                <p requiredField *ngIf="form.controls.cityId.touched && form.controls.cityId.errors && form.controls.cityId.errors.required"></p>
              </div>
            </div>
            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Postal Code" formControlName="zipcode" maxlength="10">
                </md-form-field>
                <p requiredField *ngIf=" form.controls.zipcode.touched && form.controls.zipcode.invalid"></p>
              </div>
            </div>
            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Time Zone" formControlName="timezone" [readonly]="true">
                </md-form-field>
              </div>
            </div>
            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <span *ngIf="addNewFlag.keyboardType" (click)="addNewkeyboardType()" class="addBtnCls">
                  <i class="material-icons">&#xE147;</i>
                </span>
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="Select keyboard Type or Add New" mdInput formControlName="keyboardTypeId" [mdAutocomplete]="keyboardType"
                    maxlength="200">
                  <md-autocomplete #keyboardType="mdAutocomplete" [displayWith]="_utility.displayFn">
                    <md-option *ngFor="let option of keyboardTypeFilteredOptions | async" [value]="option">
                      {{ option.name }}
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
                <p requiredField *ngIf=" form.controls.keyboardTypeId.touched && form.controls.keyboardTypeId.invalid;"></p>
                <p class="validate" *ngIf="addNewFlag.keyboardType">Please click on + icon to add new Keyboard Type</p>
              </div>
            </div>
            <div class="frmFullWidthSec">
              <hr class="line-separator">
              <div class="col s12 m4 l4">
                <div class="errorZoneSec">
                  <md-form-field class="example-full-width">
                    <input mdInput placeholder="Location Name" formControlName="locationName" maxlength="200">
                  </md-form-field>
                  <p requiredField *ngIf=" form.controls.locationName.touched && form.controls.locationName.invalid"></p>
                </div>
              </div>
              <div class="col s12 m4 l4">
                <div class="errorZoneSec">
                  <span (click)="addNewBusinessCenter()" *ngIf="addNewFlag.businessCenter" class="addBtnCls">
                    <i class="material-icons">&#xE147;</i>
                  </span>
                  <md-form-field class="example-full-width">
                    <input type="text" placeholder="Select Business Headquarters or Select New" mdInput formControlName="businessCenterId" [mdAutocomplete]="businessCenter"
                      maxlength="200">
                    <md-autocomplete #businessCenter="mdAutocomplete" [displayWith]="_utility.displayFn">
                      <md-option *ngFor="let option of businessCenterFilteredOptions | async" [value]="option">
                        {{ option.name }}
                      </md-option>
                    </md-autocomplete>
                  </md-form-field>
                  <p requiredField *ngIf=" form.controls.businessCenterId.touched && form.controls.businessCenterId.invalid;"></p>
                  <p class="validate" *ngIf="addNewFlag.businessCenter">Please click on + icon to add new Business Headquarter</p>
                </div>
              </div>
            </div>
            <div class="frmFullWidthSec">
              <div class="col m4 l4">
                <div class="errorZoneSec">
                  <md-form-field class="example-full-width">
                    <input mdInput placeholder="Location phone number" formControlName="contactInfoForCandidates" maxlength="20">
                  </md-form-field>
                  <p requiredField *ngIf="form.controls.contactInfoForCandidates.touched && form.controls.contactInfoForCandidates.errors && form.controls.contactInfoForCandidates.errors.required"></p>
                  <p validatePhoneNumber *ngIf="form.controls.contactInfoForCandidates.touched && form.controls.contactInfoForCandidates.errors && form.controls.contactInfoForCandidates.errors.pattern"></p>
                </div>
              </div>
              <div class="col s12 m4 l4">
                <div class="errorZoneSec">
                  <span (click)="addNewGroup()" *ngIf="addNewFlag.group" class="addBtnCls">
                    <i class="material-icons">&#xE147;</i>
                  </span>
                  <md-form-field class="example-full-width">
                    <input type="text" placeholder="Select Group or Add New" mdInput formControlName="proctorGroupId" [mdAutocomplete]="group"
                      maxlength="200">
                    <md-autocomplete #group="mdAutocomplete" [displayWith]="_utility.displayFn">
                      <md-option *ngFor="let option of proctorGroupFilteredOptions | async" [value]="option">
                        {{ option.name }}
                      </md-option>
                    </md-autocomplete>
                  </md-form-field>
                  <p requiredField *ngIf=" form.controls.proctorGroupId.touched && form.controls.proctorGroupId.invalid;"></p>
                  <p class="validate" *ngIf="addNewFlag.group">Please click on + icon to add new Proctor Group.</p>
                </div>
              </div>
            </div>
            <div class="frmFullWidthSec">
              <hr class="line-separator">
              <div class="col s12 m4 l4">
                <div class="errorZoneSec">
                  <md-form-field class="example-full-width">
                    <input mdInput placeholder="Administrative Contact Name" formControlName="adminName" maxlength="100">
                  </md-form-field>
                  <p requiredField *ngIf="form.controls.adminName.touched && form.controls.adminName.invalid"></p>
                </div>
              </div>
              <div class="col s12 m4 l4">
                <div class="errorZoneSec">
                  <md-form-field class="example-full-width">
                    <input mdInput type="email" placeholder="Administrative Contact Email" formControlName="adminEmail" maxlength="200">
                  </md-form-field>
                  <p requiredField *ngIf="form.controls.adminEmail.touched && form.controls.adminEmail.errors && form.controls.adminEmail.errors.required;else invalidEmail"></p>
                </div>
                <ng-template #invalidEmail>
                  <p class="validate" *ngIf="form.controls.adminEmail.touched && form.controls.adminEmail.invalid">Incorrect Email Format</p>
                </ng-template>
              </div>
              <div class="col s12 m4 l4">
                <div class="errorZoneSec">
                  <md-form-field class="example-full-width">
                    <input mdInput placeholder="Administrative Contact Phone" formControlName="adminPhone" maxlength="20">
                  </md-form-field>
                  <p requiredField *ngIf="form.controls.adminPhone.touched && form.controls.adminPhone.errors && form.controls.adminPhone.errors.required"></p>
                  <p validatePhoneNumber *ngIf="form.controls.adminPhone.touched && form.controls.adminPhone.errors && form.controls.adminPhone.errors.pattern"></p>
                </div>
              </div>

              <div class="col s12 m4 l4">
                <div class="errorZoneSec">
                  <md-form-field class="example-full-width">
                    <input mdInput placeholder="Technical Contact Name" formControlName="techName" maxlength="100">
                  </md-form-field>
                  <p requiredField *ngIf="form.controls.techName.touched && form.controls.techName.invalid"></p>
                </div>
              </div>
              <div class="col s12 m4 l4">
                <div class="errorZoneSec">
                  <md-form-field class="example-full-width">
                    <input mdInput placeholder="Technical Contact Email" formControlName="techEmail" maxlength="100" type="email">
                  </md-form-field>
                  <p requiredField *ngIf="form.controls.techEmail.touched && form.controls.techEmail.errors && form.controls.techEmail.errors.required;else invalidTempEmail"></p>
                </div>
                <ng-template #invalidTempEmail>
                  <p class="validate" *ngIf="form.controls.techEmail.touched && form.controls.techEmail.invalid">Incorrect Email Format</p>
                </ng-template>
              </div>
              <div class="col s12 m4 l4">
                <div class="errorZoneSec">
                  <md-form-field class="example-full-width">
                    <input mdInput placeholder="Technical Contact Phone" formControlName="techPhone" maxlength="20">
                  </md-form-field>
                  <p requiredField *ngIf="form.controls.techPhone.touched && form.controls.techPhone.errors && form.controls.techPhone.errors.required"></p>
                  <p validatePhoneNumber *ngIf="form.controls.techPhone.touched && form.controls.techPhone.errors && form.controls.techPhone.errors.pattern"></p>
                </div>
              </div>
              <div class="col s12 m12 l12">
                <div class="errorZoneSec">
                  <md-form-field class="example-full-width">
                    <textarea mdInput style="min-height: 15em; margin-top: 1em; margin-bottom: 1.5em;" placeholder="Instructions To Candidate" formControlName="candidateInstructions"></textarea>
                  </md-form-field>
                </div>
              </div>
            </div>
          </form>
        </md-card-content>
        <div class="col s12 m12 l12">
          <md-card-actions>
            <div class="button-row">
              <button [disabled]="this.id == 0" md-raised-button class="glbAdminBtnCls1 glbAdminBtnCls2 gabtnSizeM" (click)="openKoalaConfigDialog()">CONFIGURE SYSTEM</button>
            </div>
            <div class="button-row">
              <button [disabled]="this.form.invalid || isSaveBtnDisable || addNewFlag.businessCenter || addNewFlag.keyboardType" md-raised-button
                class="glbAdminBtnCls1" type="submit" (click)="onSubmitForm()">SAVE</button>
              <button [disabled]="isEditBtnDisable || this.status == 3" md-raised-button class="glbAdminBtnCls1" (click)="onEdit()">EDIT</button>
              <button [disabled]="this.id == 0  || this.status == Enum.StatusActive || this.status == Enum.StatusPending" md-raised-button
                class="glbAdminBtnCls1" (click)="onChangeStatus(1)">ACTIVATE</button>
              <button [disabled]="this.id == 0  || this.status == Enum.StatusRetire || this.status == Enum.StatusPending" md-raised-button
                class="glbAdminBtnCls1" (click)="onChangeStatus(3)">RETIRE</button>
              <button [disabled]="this.id == 0" md-raised-button class="glbAdminBtnCls1" [showUnSavedChangesAlert]="{form: form, redirect: ['/AdmManageLocationSetting', this.id]}"
                (click)="_appGlobals.routeWithID = true">LOCATION SETTING</button>
              <button [disabled]="this.id == 0" md-raised-button class="glbAdminBtnCls1" (click)="openConfigDomain()">CONFIG DOMAIN</button>
            </div>
          </md-card-actions>
        </div>
      </md-card>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-location/adm-update-location/adm-update-location.component.html